import React from 'react';

import {fetchEventParticipants} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';

const LoadParticipants = ({eventId, skipSpinner, children}) => {
    useStoredDataChanged();

    if (!eventId) return children;

    return (
        <Loader skipSpinner={state => skipSpinner || state.events[eventId]?.participants.loaded} promises={[fetchEventParticipants(eventId)]}>
            {children}
        </Loader>
    );
};

export default LoadParticipants;
